import React, { useState } from 'react';
import EventManagementView from 'screens/Admin/EventManagement/components/View';
import useFetchTableData from 'hooks/useFetchTableData';
import AdminEventServices from 'services/api/Event';
import AdminContainer from 'components/Admin/AdminContainer';
import { useParams } from 'react-router-dom';

function EventManagementScreen() {
  const { id, type } = useParams();

  const [dataReloaded, setDataReloaded] = useState( new Date().valueOf() );
  const { fetchData, data, dataLoading } = useFetchTableData( {
    promise: ( params ) => AdminEventServices.getAllEvents( params ),
    deps: [dataReloaded],
  } );

  return (
    <AdminContainer
      headerTitle="dddwdw"
      type={type}
      id={id ? Number( id ) : undefined}
    >
      <EventManagementView
        events={data}
        fetchData={fetchData}
        isLoading={dataLoading}
        reloadData={() => setDataReloaded( new Date().valueOf() )}
      />
    </AdminContainer>
  );
}

export default EventManagementScreen;
